// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".float-whats[data-v-5319f6e8]{position:fixed;z-index:50;cursor:pointer;width:40px;height:40px;display:block;top:80%;right:16px;bottom:16px}@media (min-width:992px){.float-whats[data-v-5319f6e8]{width:56px;height:56px;right:24px;bottom:24px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
